import React, { useState } from 'react';
import styled from 'styled-components';
import { Flex, Button } from '../primitives';
import AdvancedSearchV2Filter from './AdvancedSearchV2Filter';
import AdvancedSearchV2VerticalFilter from './AdvancedSearchV2VerticalFilter';
import AdvancedSearchV2LocationFilter from './AdvancedSearchV2LocationFilter';
import ViewSavedSearchesModal from './ViewSavedSearchesModal';
import SaveSearchModal from './SaveSearchModal';
import AdvancedSearchTimeframeFilter from './AdvancedSearchTimeframeFilter';

const Container = styled.div`
  .card-block {
    h5,
    h3 {
      margin-bottom: 0;
    }
    label {
      margin-top: 0;
    }
  }
`;

export default function AdvancedSearchV2FiltersBar({ isModal, resetFilters }) {
  const [showSavedSearchesModal, setShowSavedSearchesModal] = useState(false);
  const [showSaveSearchModal, setShowSaveSearchModal] = useState(false);

  return (
    <Container>
      <div className="card-block">
        {isModal ? <h5>Vertical</h5> : <h3>Vertical</h3>}
        <AdvancedSearchV2VerticalFilter />
      </div>
      <div className="card-block">
        {isModal ? <h5>Filters</h5> : <h3>Filters</h3>}
        <AdvancedSearchV2Filter filterList="stage" filterLabel="Company Stage" />
        <AdvancedSearchV2Filter filterList="vc_score" filterLabel="VC Score" />
        <AdvancedSearchTimeframeFilter filterList="timeframe" filterLabel="Timeframe" />
        <AdvancedSearchV2Filter filterList="round_type" filterLabel="Round Type" />
        <AdvancedSearchV2LocationFilter resetFilters={resetFilters} />
        <Flex justify="space-between">
          <Button onClick={() => setShowSavedSearchesModal(true)}>View Searches</Button>
          <Button onClick={() => setShowSaveSearchModal(true)}>Save Search</Button>
        </Flex>
      </div>

      <ViewSavedSearchesModal
        showModal={showSavedSearchesModal}
        onClose={() => setShowSavedSearchesModal(false)}
      />

      <SaveSearchModal
        showModal={showSaveSearchModal}
        onClose={() => setShowSaveSearchModal(false)}
      />
    </Container>
  );
}
